export default "__VITE_ASSET__CF5PA$5w__"